export class DataTransferCP {
    chargePointId: number;
    vendorId: string;
    messageId: string;
    data: string;
    reason: string;
}